const encoder = new TextEncoder();

export async function hashObject(obj: object): Promise<string> {
  const str = JSON.stringify(obj, Object.keys(obj).sort());
  const buffer = await crypto.subtle.digest('SHA-1', encoder.encode(str));
  const bytes = new Uint8Array(buffer);
  let hex = '';
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, '0');
  }
  return hex;
}
